import { render, staticRenderFns } from "./DepartmentManager.vue?vue&type=template&id=667b174c&scoped=true"
import script from "./DepartmentManager.vue?vue&type=script&lang=js"
export * from "./DepartmentManager.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManager.vue?vue&type=style&index=0&id=667b174c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667b174c",
  null
  
)

export default component.exports